import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { Settings, Tournament } from "../../../../shared/models";
import { User } from "../../../../shared/models/user";
import { AuthService } from "../../../../auth/auth.service";
import { TournamentStatus2 } from "../../../../shared/enums/poker-types";

@Component({
  selector: "view-tournament-structure",
  templateUrl: "./view-tournament-structure.component.html",
  styleUrls: ["./view-tournament-structure.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewTournamentStructureComponent implements OnInit {
  @Input() user: User;
  @Input() tournament: Tournament;
  data: any[] = [];
  settings: Settings;
  currentItem: any = null;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.settings = this.authService.settings;
    this.updateCurrentItem();
    setInterval(() => this.updateCurrentItem(), 60000);
  }

  ngAfterViewInit() {
    this.data = this.getCombinedData();
  }

  getCombinedData(): any[] {
    if (!this.tournament?._blindLevels || !this.tournament?.tourSum) {
      return [];
    }

    const combined = [];
    const {
      PeriodDuration,
      AddonBreakOn,
      BreakEvery,
      LateRegistrationPeriod,
      ReBuyPeriod,
      OptionSyncronizedBreak,
    } = this.tournament.tourSum;

    this.tournament._blindLevels.forEach((level, index) => {
      combined.push({
        type: "blind",
        id: combined.length + 1,
        level: index + 1,
        blind: level.Blind,
        ante: level.Ante,
        startTime: level.PeriodStartMinutes,
        duration: PeriodDuration,
      });
      const nextEventTime = level.PeriodStartMinutes + PeriodDuration;

      if (LateRegistrationPeriod === index + 1) {
        combined.push({
          id: combined.length + 1,
          type: "late_reg_end",
          startTime: nextEventTime,
          duration: 0,
        });
      }

      if (ReBuyPeriod === index + 1) {
        combined.push({
          id: combined.length + 1,
          type: "rebuy_end",
          startTime: nextEventTime,
          duration: 0,
        });
      }
      if (AddonBreakOn === index + 1) {
        combined.push({
          id: combined.length + 1,
          type: "addon_break",
          startTime: nextEventTime,
          duration: this.settings?.AddOnBreakDuration,
        });
      }

      if (
        !OptionSyncronizedBreak &&
        BreakEvery > 0 &&
        (index + 1) % BreakEvery === 0
      ) {
        combined.push({
          id: combined.length + 1,
          type: "break",
          startTime: nextEventTime,
          duration: this.settings?.BreakDuration,
        });
      }
    });
    return combined.sort((a, b) => a.startTime - b.startTime);
  }

  updateCurrentItem() {
    this.currentItem = this.getCurrentItem();
  }

  getCurrentItem() {
    if (
      this.tournament?.tourSum?.Status2 !==
        TournamentStatus2.RunningRegistrationClosed &&
      this.tournament?.tourSum?.Status2 !==
        TournamentStatus2.RunningWithLateRegistration
    ) {
      return null;
    }
    if (
      !this.tournament?.tourSum?.DateStarting ||
      !this.data?.length
    ) {
      return null;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.tournament.tourSum.DateStarting).getTime();

    const elapsedMinutes = (now - startTime) / (1000 * 60);
    let cumulativeTime = 0;

    for (const item of this.data) {
      const itemEndTime = cumulativeTime + (item.duration || 0);

      if (elapsedMinutes >= cumulativeTime && elapsedMinutes < itemEndTime) {
        return item;
      }

      cumulativeTime = itemEndTime;
    }

    return null;
  }
}
